import { render, staticRenderFns } from "./AreaGuideSuccess.vue?vue&type=template&id=008c44a3&scoped=true&"
import script from "./AreaGuideSuccess.vue?vue&type=script&lang=js&"
export * from "./AreaGuideSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AreaGuideSuccess.vue?vue&type=style&index=0&id=008c44a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c44a3",
  null
  
)

export default component.exports